<template>
  <span v-if="loading" class="skeleton-loader-background"></span>
  <span v-else><slot /></span>
</template>
<script>
export default {
  name: "Shimmer",
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.skeleton-loader-background {
  width: 100%;
  height: 15px;
  display: block;
  background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(207, 207, 207, 0.5) 50%,
      rgba(255, 255, 255, 0) 80%
    ),
    rgb(255, 255, 255);
  background-repeat: repeat-y;
  background-size: 50px 500px;
  background-position: 0 0;
  animation: shine 1s infinite;
}
@keyframes shine {
  to {
    background-position: 100% 0;
  }
}
</style>
